export default {
    "enum.success": "Success",
    "enum.delete.items": "{value} items deleted",
    "enum.copy": "複製",
    "enum.delete": "刪除",
    "enum.ev_charger.ev_system.ccs1": "CCS1",
    "enum.ev_charger.ev_system.ccs2": "CCS2",
    "enum.ev_charger.ev_system.type1": "Type1",
    "enum.ev_charger.ev_system.type2": "Type2",
    "enum.ev_charger.ev_system.acgbt": "ACGBT",
    "enum.ev_charger.ev_system.dcgbt": "DCGBT",
    "enum.ev_charger.ev_system.chademo": "CHAdeMo",
    "enum.ev_charger.ev_system.online": "online",
    "enum.ev_charger.ev_system.offline": "offline",
    "enum.ev_charger.ev_system.connector_fault": "Connector Fault",
    "enum.ev_charger.current_type.dc": "DC",
    "enum.ev_charger.current_type.ac": "AC",
    'enum.document.type.image_jpeg': "jpeg",
    'enum.document.type.image_png': "png",
    'enum.document.type.image_webp': "webp",
    'enum.document.type.video_mp4': "mp4",
    'enum.document.type.unknown': "unknown",
    "enum.value.boolean.true": "True",
    "enum.value.boolean.false": "False",
};
